import Swiper, { Navigation, Scrollbar } from 'swiper';
import 'swiper/css';

export default function () {
    const swiper = new Swiper('.js-info-with-gallery', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        breakpoints: {
            540: {
                slidesPerView: 2,
                spaceBetween: 40,
            },
        },
        modules: [Navigation, Scrollbar],
        navigation: {
            nextEl: '.js-info-with-gallery__next',
            prevEl: '.js-info-with-gallery__prev',
        },
        scrollbar: {
            el: '.swiper-scrollbar',
            hide: false,
            dragSize: 180,
        },
    });
}